export class GroupPresenter {
  constructor(group) {
    this.id = group.id;
    this.name = group.name;
    this.isAffectApp = group.isAffectApp;
    this.deletedAt = group.deletedAt;
    this.route = { name: "PackageGroupMainDetailPage", params: { id: group.id } };
  }
}